import { createBrowserRouter, Navigate, Outlet } from "react-router";
import { UserRole } from "../types/ApiTypes";
import { RoleMiddleware } from "./middleware/RoleMiddleware";
import BuyGiftcardAssetManagement from "./pages/asset_management/BuyGiftcardAssetManagement";
import CryptoAssetManagement from "./pages/asset_management/CryptoAssetManagement";
import SellGiftcardAssetManagement from "./pages/asset_management/SellGiftcardAssetManagement";
import ActivityLog from "./pages/notifications/ActivityLog.tsx";
import Notifications from "./pages/notifications/Notifications.tsx";
import Overview from "./pages/Overview";
import PendingGiftcard from "./pages/PendingGiftcard";
import FeesPage from "./pages/rates_fees/fees/Fees.tsx";
import BuyGiftcardRates from "./pages/rates_fees/rates/BuyGiftcard.tsx";
import DollarConversionRates from "./pages/rates_fees/rates/DollarConversion.tsx";
import Rates from "./pages/rates_fees/rates/Rates.tsx";
import SellGiftcardRates from "./pages/rates_fees/rates/SellGiftcard.tsx";
import WithdrawalLimits from "./pages/rates_fees/WithdrawalLimits.tsx";
import SettingsAdmin from "./pages/settings/SettingsAdmin.tsx";
import SettingsGeneral from "./pages/settings/SettingsGeneral.tsx";
import SignIn from "./pages/SignIn";
import Transactions from "./pages/Transactions";
import UserDetails from "./pages/user_management/UserDetails";
import UserManagement from "./pages/user_management/UserManagement";

export const router = createBrowserRouter([
   {
      path: "/",
      element: (
         <RoleMiddleware>
            <Outlet />
         </RoleMiddleware>
      ),
      children: [
         {
            index: true,
            element: <Navigate to="/overview" replace />
         },
         {
            path: "overview",
            element: <Overview />
         },
         {
            path: "transactions",
            element: <Transactions />
         },
         {
            path: "pending-giftcard",
            element: <PendingGiftcard />
         },
         {
            path: "users",
            children: [
               {
                  index: true,
                  element: <UserManagement />
               },
               {
                  path: ":userId",
                  element: <UserDetails />
               }
            ]
         },
         {
            path: "assets",
            children: [
               {
                  index: true,
                  element: <CryptoAssetManagement />
               },
               {
                  path: "giftcard/sell",
                  element: <SellGiftcardAssetManagement />
               },
               {
                  path: "giftcard/buy",
                  element: <BuyGiftcardAssetManagement />
               }
            ]
         },
         {
            path: "rates",
            children: [
               {
                  index: true,
                  element: <Rates />
               },
               {
                  path: "giftcard/buy",
                  element: <BuyGiftcardRates />
               },
               {
                  path: "giftcard/sell",
                  element: <SellGiftcardRates />
               },
               {
                  path: "dollar-conversion",
                  element: <DollarConversionRates />
               },
               {
                  path: "fees",
                  element: <FeesPage />
               },
               {
                  path: "withdrawal-limits",
                  element: (
                     <RoleMiddleware allowedRoles={[UserRole.SUPERADMIN]}>
                        <WithdrawalLimits />
                     </RoleMiddleware>
                  )
               }
            ]
         },
         {
            path: "notifications",
            children: [
               {
                  index: true,
                  element: <Notifications />
               },
               {
                  path: "activity-log",
                  element: <ActivityLog />
               }
            ]
         },
         {
            path: "settings",
            children: [
               {
                  index: true,
                  element: <SettingsGeneral />
               },
               {
                  path: "admin",
                  element: (
                     <RoleMiddleware allowedRoles={[UserRole.SUPERADMIN]}>
                        <SettingsAdmin />
                     </RoleMiddleware>
                  )
               }
            ]
         }
      ]
   },
   {
      path: "/login",
      element: <SignIn />
   }
]);